import { Label, TextFormField } from '@busybusy/webapp-react-ui';
import { t } from 'i18next';
import { Fragment } from 'react';
import { v_fields_match, v_min_length, v_require, v_valid_email } from 'utils/validations';

export function renderCompanyNameFormField(form: any, onFocus: () => void, onBlur: () => void) {
  return (
    <Fragment key="companyName">
      <Label>{t('Company Name')}</Label>
      <TextFormField
        name="companyName"
        onFocus={onFocus}
        onBlur={onBlur}
        validations={[{ validation: v_require }]}
        form={form}
      />
    </Fragment>
  );
}

export function renderEmailFormField(form: any, onFocus: () => void, onBlur: () => void) {
  return (
    <Fragment key="email">
      <Label>{t('Email')}</Label>
      <TextFormField
        name="email"
        onFocus={onFocus}
        onBlur={onBlur}
        validations={[{ validation: v_require }, { validation: v_valid_email }]}
        form={form}
      />
    </Fragment>
  );
}

export function renderPasswordField(form: any, onFocus: () => void, onBlur: () => void) {
  return (
    <Fragment key="password">
      <Label secondaryLabel={t('Password must be at least 8 characters')}>{t('Password')}</Label>
      <TextFormField
        form={form}
        type="password"
        name="password"
        onFocus={onFocus}
        onBlur={onBlur}
        validations={[
          { validation: v_require },
          { validation: v_min_length, args: { min: 8, message: t('Minimum 8 characters') } },
        ]}
      />
    </Fragment>
  );
}

export function renderConfirmPasswordField(form: any, onFocus: () => void, onBlur: () => void) {
  return (
    <Fragment key="confirm-password">
      <Label>{t('Confirm password')}</Label>
      <TextFormField
        form={form}
        name="confirmPassword"
        type="password"
        onFocus={onFocus}
        onBlur={onBlur}
        validations={[
          { validation: v_require },
          { validation: v_fields_match, args: { matchingField: 'password', message: t('Passwords must match') } },
        ]}
      />
    </Fragment>
  );
}
